var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M51 25.5C51 11.4152 39.5848 0 25.5 0C11.4152 0 0 11.4152 0 25.5C0 39.5848 11.4152 51 25.5 51C25.6494 51 25.7988 51 25.9482 50.99V31.1479H20.4697V24.7629H25.9482V20.0613C25.9482 14.6127 29.2752 11.6443 34.1361 11.6443C36.467 11.6443 38.4691 11.8137 39.0469 11.8934V17.591H35.7C33.0604 17.591 32.5424 18.8461 32.5424 20.6889V24.7529H38.8676L38.0408 31.1379H32.5424V50.0139C43.2006 46.9559 51 37.1443 51 25.5Z","fill":"white"}));
}

FacebookInline.defaultProps = {"width":"51","height":"51","viewBox":"0 0 51 51","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
